import React, { useState, useEffect} from 'react';
import { useSearchParams } from 'react-router-dom';
import language from '../../../utils/LanguageSettings';
import { fetchSupport, fetchSupportSearchResult } from '../../functions/fetchSupport';
import '../../../css/support.css'
import translations from '../../../text/get-started-translations.json';
import SupportSearchSuggestion from './SupportSearchSuggestion';
import tel from '../../../images/icon/tel.png';
import { SOURCE_URL } from '../../../config';
import RenderSnA from '../../functions/renderSnA';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';

interface SupportSearchResultProps {

}

const SupportSearchResult: React.FC<SupportSearchResultProps> = () => {
    const [searchParams] = useSearchParams();
    const pageTranslations = translations[language];
    const [loading, setLoading] = useState<boolean>(true);
    const [keyword, setKeyword] = useState(searchParams.get('keyword'));
    const [allData, setAllData] = useState<any>();
    const [myAccountData, setMyAccountData] = useState<any>();
    const [nowPlayerData, setNowPlayerData] = useState<any>();
    const [setTopBoxData, setSetTopBoxData] = useState<any>();
    const [smartTvAppInterfaceData, setSmartTvAppInterfaceData] = useState<any>();
    const [tvInterfacesData, setTvInterfacesData] = useState<any>();
    const [othersData, setOthersData] = useState<any>();
    const [active, setActive] = useState<string>("all");
    const [supportData, setSupportData] = useState<any>();
    const [isSearch, setIsSearch] = useState<boolean>(false);
    const [seo, setSeo] = useState<any>(null);
    const [ga, setGa] = useState<any>(null);

    useEffect(() => {
        const fetchData = async () => {
            let data = await fetchSupportSearchResult(language, searchParams.get('keyword'));
            if(data){
                setAllData(data);
                handleResultData(data);
            }
            let supportData = await fetchSupport(language);
            if(supportData){
                setSupportData(supportData?.data?.attributes);
                setGa(supportData?.data?.attributes?.GA || null);
                setSeo(supportData?.data?.attributes?.SEO || null);
                setLoading(false);
            }
        };
        fetchData();
    }, [language,searchParams.get('keyword')]);

    const handleChange = (event: { target: { value: any; }; }) => {
        setKeyword(event.target.value);
        setIsSearch(true);
    };

    const handleResultData = (data: any) => {
        const myAccount: { category: { toString: () => string | string[]; }; }[] = [];
        const nowPlayer: { category: { toString: () => string | string[]; }; }[] = [];
        const setTopBox: { category: { toString: () => string | string[]; }; }[] = [];
        const smartTvAppInterface: { category: { toString: () => string | string[]; }; }[] = [];
        const tvInterfaces: { category: { toString: () => string | string[]; }; }[] = [];
        const others: { category: { toString: () => string | string[]; }; }[] = [];

        data.forEach((element: { category: { toString: () => string | string[]; }; }) => {
            if(element?.category.toString().indexOf("My Account") > -1){
                myAccount.push(element);
            }
            if(element?.category.toString().indexOf("Now Player") > -1){
                nowPlayer.push(element);
            }
            if(element?.category.toString().indexOf("Set Top Box") > -1){
                setTopBox.push(element);
            }
            if(element?.category.toString().indexOf("Smart TV App Interface") > -1){
                smartTvAppInterface.push(element);
            }
            if(element?.category.toString().indexOf("TV Interfaces") > -1){
                tvInterfaces.push(element);
            }
            if(element?.category.toString().indexOf("Uncategorized") > -1){
                others.push(element);
            }
        });
        setMyAccountData(myAccount);
        setNowPlayerData(nowPlayer);
        setSetTopBoxData(setTopBox);
        setSmartTvAppInterfaceData(smartTvAppInterface);
        setTvInterfacesData(tvInterfaces);
        setOthersData(others);
    };

    const onClick = (tab: string) =>{
        setActive(tab);
    };

    const handleData = (data: any) => {
        return Array.isArray(data) && data.map((item,index) => (
            <div key={index}>
                <a href={"/support/"+item?.slug} className="with-arrow p-relative d-block w-100 py-3 pr-4 support-a">
                    <h5 className="font-medium">{language == "en" ? item?.nameEn : item?.nameZh}</h5>
                </a>
                <hr className="my-3 thin-light" />
            </div>
        ))
    };

    const handleNoResultData = (data: any) => {
        if(data){
            return Array.isArray(data) && data.map((item, index) => (
                <div className="col-lg-2-5 col-md-4" key={index}>
                    <a className="box px-2 d-flex lg_font_size" href={window.location.origin + "/support/" + item?.attributes?.slug}>{item?.attributes?.Name}</a>
                </div>
            ));
        }
    }

    const handleDataFromChild = (data: any) => {
        setKeyword(data);
        setIsSearch(false);
    }

    const validateInput = () => {
        const input = document.querySelector('input[name="keyword"]');
        const value = input.value;
        const pattern = /<.*?>|javascript:|on\w+=/gi;
        if (pattern.test(value)) {
            input.value = '';
            return false;
        }
        return true;
    }
  
    if (loading) {
        return (<>
            <div id="loader">
                <div className="spinner-border"></div>
            </div>
        </>
        );
    }
    return (
      <>
        <RenderSnA seo={seo} ga={ga} />
        <section id="search" className="spacer-top mb-5" style={language=="en" ? {fontFamily:"Montserrat"} : {fontFamily: "Noto Sans TC"}}>
            <div className="container-fluid">
                <h1 className="text-center mb-5 font-medium">{supportData?.SupportSearchResultTitle}</h1>
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-sm-12">
                        <form className="input-group search-support position-relative mx-auto" action="/support-search-result" autoComplete="off" onSubmit={validateInput}>
                            <input type="text" placeholder={supportData?.search_bar_placeholder} name="keyword" value={keyword} className="mb-0 form-control search-field" onChange={handleChange}/>
                                <div className="input-group-append">
                                    <button type="submit" className="input-group-text">
                                        <i className="icon-search-icon lg_font_size mr-3 align-middle"></i>
                                        <span>{supportData?.search_bar_button_label}</span>
                                    </button>
                                </div>
                                <div className="suggestions">
                                    <SupportSearchSuggestion query={keyword} isSearch={isSearch} onData={handleDataFromChild} />
                                </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        {allData && allData.length > 0 ?
        <section id="search-result" className="support-search" style={language=="en" ? {fontFamily:"Montserrat"} : {fontFamily: "Noto Sans TC"}}>
            <div className="container-fluid spacer-bottom pt-4">
                <h3 className="text-center font-medium">{`“`+searchParams.get('keyword')+`”`}</h3>
                <div className="search-results-area p-relative">
                    <div className="py-sm-5 py-4 search-results">
                        <div className="row justify-content-center mb-5 small-margin tabbed-buttons">
                            <div className="col-xl col-lg-2 col-md-4 col-6 mb-xl-0 mb-3">
                                <button type="button" className={active == "all" ? "w-100 sub-cat active" : "w-100 sub-cat"} onClick={() => onClick("all")}>{pageTranslations.all+ ` (`+allData?.length+`)`}</button>
                            </div>
                            {myAccountData?.length > 0 ?
                            <div className="col-xl col-lg-3 col-md-4 col-6 mb-xl-0 mb-3">
                                <button type="button" className={active == "my-account" ? "w-100 sub-cat active" : "w-100 sub-cat"} onClick={() => onClick("my-account")}>{pageTranslations["my-account"]+ ` (`+myAccountData?.length+`)`}</button>
                            </div>
                            :<></>}
                            {nowPlayerData?.length > 0 ?
                            <div className="col-xl col-lg-3 col-md-4 col-6 mb-xl-0 mb-3">
                                <button type="button" className={active == "now-player" ? "w-100 sub-cat active" : "w-100 sub-cat"} onClick={() => onClick("now-player")}>{pageTranslations["now-player"]+ ` (`+nowPlayerData?.length+`)`}</button>
                            </div>
                            :<></>}
                            {setTopBoxData?.length > 0 ?
                            <div className="col-xl col-lg-3 col-md-4 col-6 mb-xl-0 mb-3">
                                <button type="button" className={active == "set-top-box" ? "w-100 sub-cat active" : "w-100 sub-cat"} onClick={() => onClick("set-top-box")}>{pageTranslations["set-top-box"]+ ` (`+setTopBoxData?.length+`)`}</button>
                            </div>
                            :<></>}
                            {smartTvAppInterfaceData?.length > 0 ? 
                            <div className="col-xl col-lg-3 col-md-4 col-6 mb-xl-0 mb-3">
                                <button type="button" className={active == "smart-tv-app-interface" ? "w-100 sub-cat active" : "w-100 sub-cat"} onClick={() => onClick("smart-tv-app-interface")}>{pageTranslations["smart-tv-app-interface"]+ ` (`+smartTvAppInterfaceData?.length+`)`}</button>
                            </div>
                            :<></>}
                            {tvInterfacesData?.length > 0 ?
                            <div className="col-xl col-lg-3 col-md-4 col-6 mb-xl-0 mb-3">
                                <button type="button" className={active == "tv-interfaces" ? "w-100 sub-cat active" : "w-100 sub-cat"} onClick={() => onClick("tv-interfaces")}>{pageTranslations["tv-interfaces"]+ ` (`+tvInterfacesData?.length+`)`}</button>
                            </div>
                            :<></>}
                            {othersData?.length > 0 ?
                            <div className="col-xl col-lg-3 col-md-4 col-6 mb-xl-0 mb-3">
                                <button type="button" className={active == "others" ? "w-100 sub-cat active" : "w-100 sub-cat"} onClick={() => onClick("others")}>{pageTranslations["others"]+ ` (`+othersData?.length+`)`}</button>
                            </div>
                            : <></>}
                        </div>
                        {myAccountData?.length > 0 && (active == "all" || active == "my-account") ?
                        <div className="grouped-result mb-5" id="my-account">
                            <div className="p-relative">
                                <h5 className="font-weight-bold py-3">{pageTranslations["my-account"]+ `(`+myAccountData?.length+`)`}</h5>
                                {myAccountData?.length > 5 ?
                                <a className="color-1 arrowed-link barlow-font d-sm-block d-none more-result" href={"/frequently-read-articles?cat=my-account&keyword="+searchParams.get('keyword')}>
                                    {pageTranslations.more}{pageTranslations["my-account"]}{pageTranslations.results}<i className="icon-angle-right"></i>
                                </a>
                                :<></>}
                            </div>
                            <hr className="my-3 thin-light" />
                            <div>
                                {handleData(myAccountData?.slice(0,5))}
                            </div>
                        </div>
                        : <></>}
                        {nowPlayerData?.length > 0 && (active == "all" || active == "now-player") ?
                        <div className="grouped-result mb-5" id="now-player">
                            <div className="p-relative">
                                <h5 className="font-weight-bold py-3">{pageTranslations["now-player"]+ `(`+nowPlayerData?.length+`)`}</h5>
                                {nowPlayerData?.length > 5 ?
                                <a className="color-1 arrowed-link barlow-font d-sm-block d-none more-result" href={"/frequently-read-articles?cat=now-player&keyword="+searchParams.get('keyword')}>
                                    {pageTranslations.more}{pageTranslations["now-player"]}{pageTranslations.results}<i className="icon-angle-right"></i>
                                </a>
                                :<></>}
                            </div>
                            <hr className="my-3 thin-light" />
                            <div>
                                {handleData(nowPlayerData?.slice(0,5))}
                            </div>
                        </div>
                        : <></>}
                        {setTopBoxData?.length > 0 && (active == "all" || active == "set-top-box") ?
                        <div className="grouped-result mb-5" id="set-top-box">
                            <div className="p-relative">
                                <h5 className="font-weight-bold py-3">{pageTranslations["set-top-box"]+ `(`+setTopBoxData?.length+`)`}</h5>
                                {setTopBoxData?.length > 5 ?
                                <a className="color-1 arrowed-link barlow-font d-sm-block d-none more-result" href={"/frequently-read-articles?cat=set-top-box&keyword="+searchParams.get('keyword')}>
                                    {pageTranslations.more}{pageTranslations["set-top-box"]}{pageTranslations.results}<i className="icon-angle-right"></i>
                                </a>
                                :<></>}
                            </div>
                            <hr className="my-3 thin-light" />
                            <div>
                                {handleData(setTopBoxData?.slice(0,5))}
                            </div>
                        </div>
                        : <></>}
                        {smartTvAppInterfaceData?.length > 0 && (active == "all" || active == "smart-tv-app-interface") ?
                        <div className="grouped-result mb-5" id="smart-tv-app-interface">
                            <div className="p-relative">
                                <h5 className="font-weight-bold py-3">{pageTranslations["smart-tv-app-interface"]+ `(`+smartTvAppInterfaceData?.length+`)`}</h5>
                                {smartTvAppInterfaceData?.length > 5 ?
                                <a className="color-1 arrowed-link barlow-font d-sm-block d-none more-result" href={"/frequently-read-articles?cat=smart-tv-app-interface&keyword="+searchParams.get('keyword')}>
                                    {pageTranslations.more}{pageTranslations["smart-tv-app-interface"]}{pageTranslations.results}<i className="icon-angle-right"></i>
                                </a>
                                :<></>}
                            </div>
                            <hr className="my-3 thin-light" />
                            <div>
                                {handleData(smartTvAppInterfaceData?.slice(0,5))}
                            </div>
                        </div>
                        : <></>}
                        {tvInterfacesData?.length > 0 && (active == "all" || active == "tv-interfaces") ?
                        <div className="grouped-result mb-5" id="tv-interfaces">
                            <div className="p-relative">
                                <h5 className="font-weight-bold py-3">{pageTranslations["tv-interfaces"]+ `(`+tvInterfacesData?.length+`)`}</h5>
                                {tvInterfacesData?.length > 5 ?
                                <a className="color-1 arrowed-link barlow-font d-sm-block d-none more-result" href={"/frequently-read-articles?cat=tv-interfaces&keyword="+searchParams.get('keyword')}>
                                    {pageTranslations.more}{pageTranslations["tv-interfaces"]}{pageTranslations.results}<i className="icon-angle-right"></i>
                                </a>
                                :<></>}
                            </div>
                            <hr className="my-3 thin-light" />
                            <div>
                                {handleData(tvInterfacesData?.slice(0,5))}
                            </div>
                        </div>
                        : <></>}
                        {othersData?.length > 0 && (active == "all" || active == "others") ?
                        <div className="grouped-result mb-5" id="others">
                            <div className="p-relative">
                                <h5 className="font-weight-bold py-3">{pageTranslations["others"]+ `(`+othersData?.length+`)`}</h5>
                                {othersData?.length > 5 ?
                                <a className="color-1 arrowed-link barlow-font d-sm-block d-none more-result" href={"/frequently-read-articles?cat=uncategorized&keyword="+searchParams.get('keyword')}>
                                    {pageTranslations.more}{pageTranslations["uncategorized"]}{pageTranslations.results}<i className="icon-angle-right"></i>
                                </a>
                                :<></>}
                            </div>
                            <hr className="my-3 thin-light" />
                            <div>
                                {handleData(othersData?.slice(0,5))}
                            </div>
                        </div>
                        : <></>}
                    </div>    
                </div>
            </div>
        </section>
        :
        <section id="search-result" style={language=="en" ? {fontFamily:"Montserrat"} : {fontFamily: "Noto Sans TC"}}>
            <div className="container-fluid spacer-bottom pt-4">
                <h3 className="text-center font-medium" style={language=="en" ? {fontFamily:"Montserrat"} : {fontFamily: "Noto Sans TC"}}>{supportData?.no_result_text.replace("{keyword}",searchParams.get('keyword'))}</h3>
                <div className="d-flex justify-content-center py-5 no-result-suggestion lg_font_size barlow-font light-gray">
                    <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{supportData?.no_result_suggestions}</ReactMarkdown>
                </div>
            </div>
            <section id="select-topic" className="pb-5">
                <div className="container">
                    <div className="row topic-row justify-content-center">
                        {handleNoResultData(supportData?.suggested_topics?.data)}
                    </div>
                </div>
            </section>
            <section className="light-gray-bg spacer text-center">
                <h3 className="mb-5 font-medium">{supportData?.contact_us_title}</h3>
                <a href={supportData?.contact_us_link}>
                    <img src={SOURCE_URL + supportData?.contact_us_icon?.data?.attributes?.url} className="mx-auto img-fluid contact-icon" />
                </a>
                <div className="lg_font_size mt-3 barlow-font">
                    <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{supportData?.contact_us_label}</ReactMarkdown>
                </div>
            </section>
        </section>
        }
      </>
    );
};

export default SupportSearchResult;